/**
 * Content Domain — Taxonomy Barrel Export
 *
 * Public API for the taxonomy system.
 * All consumers should import from this barrel or from the
 * backward-compatible proxy at src/config/taxonomyRegistry.ts.
 *
 * Created in R23 (DDD Fase 3 — taxonomy split + move).
 * Updated in R24: tiers.ts added to taxonomy subdomain.
 */

// Types
export type { FamilyDefinition } from './types'
export type { TierConfig } from './tiers'

// Tier system (moved from config/tiers.ts in R24)
export {
  TIERS,
  tierToNiveauCode,
  niveauCodeToTier,
  isTierNiveauSynced,
  isValidTier,
  isValidNiveauCode,
  getTierConfig,
  getTiersForGroup,
  getTierLabel,
  getTierTitle,
  getAllTiers,
  MAX_TIER,
  MIN_TIER,
  getAllowedTiersForGroup,
  isTierAllowedForGroup,
  clampTierToGroup,
  getGroupForTier,
  getTierRangeForGroup,
} from './tiers'

// Data (canonical array + lookup maps)
export {
  TAXONOMY,
  FAMILY_BY_ID,
  FAMILY_BY_SUBSKILL,
  FAMILIES_BY_MODULE,
  FAMILIES_BY_MODULE_SKILL,
} from './taxonomyRegistry'

// Per-module data (for direct access if needed)
export { GET_FAMILIES } from './data/GET'
export { REK_FAMILIES } from './data/REK'
export { MET_FAMILIES } from './data/MET'
export { TIJD_FAMILIES } from './data/TIJD'
export { GELD_FAMILIES } from './data/GELD'
// TGL_FAMILIES removed — TGL module deprecated (split into TIJD + GELD, s31). 0 consumers (s42+s44 grep). Data file retained.
export { SWW_FAMILIES } from './data/SWW'
export { SPR_FAMILIES } from './data/SPR'
export { TAA_FAMILIES } from './data/TAA'
export { TOPO_FAMILIES } from './data/TOPO'
export { STU_FAMILIES } from './data/STU'

// Lookup helpers
export {
  isValidFamilyId,
  getFamilyDefinition,
  getFamiliesForModule,
  getTierForFamily,
  isValidSubSkill,
  getFamilyBySubSkill,
  validateFamilyConsistency,
  getAuthoritativeTier,
  getAuthoritativeLevelCode,
  getSkillsForModule,
  getModuleScopedSkillKey,
  getFamiliesForModuleSkill,
  getAllModuleScopedSkills,
  isValidModuleSkill,
  getSkillStatsForModule,
  validateSkillConsistency,
  getLargestSkills,
  getTaxonomyStats,
} from './taxonomyHelpers'
